import './Page.css';

function Contact() {
  return (
    <main className="page">
      <h1>Contact</h1>
      <div className="content-container">
        <section className="content-section">
          <p>
            Have feedback, suggestions, or questions about Positive? I'm looking
            for ways to improve the experience and would love to hear your thoughts.
          </p>
          <div className="contact-card center">
            <p className="contact-label">Send your feedback to:</p>
            <a href="mailto:feedback.timje@gmail.com" className="contact-email">
              feedback.timje@gmail.com
            </a>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Contact;
